import { render, staticRenderFns } from "./SliceCategory.vue?vue&type=template&id=314f79e6&lang=pug&"
import script from "./SliceCategory.vue?vue&type=script&lang=js&"
export * from "./SliceCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports